/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useMemo, useState } from 'react';

import { selectStreamOptions } from '@vlabs/monokit/entities/sources/luna-streams/store/streams';
import x32 from '@vlabs/shared/assets/images/point/3x2.png';
import x33 from '@vlabs/shared/assets/images/point/3x3.png';
import x43 from '@vlabs/shared/assets/images/point/4x3.png';
import x44 from '@vlabs/shared/assets/images/point/4x4.png';
import x54 from '@vlabs/shared/assets/images/point/5x4.png';
import x55 from '@vlabs/shared/assets/images/point/5x5.png';
import fourParts from '@vlabs/shared/assets/images/point/fourParts.png';
import horizontal from '@vlabs/shared/assets/images/point/horizontal.png';
import vertical from '@vlabs/shared/assets/images/point/vertical.png';
import { Control, Divider } from '@vlabs/uikit';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import st from './SettingsModal.module.sass';

function SettingsModalComponent({ sources, onSubmit, defaultValues }) {
  const { t } = useTranslation();
  const formMethods = useForm({ defaultValues });
  const { handleSubmit, control, watch, register, setValue } = formMethods;
  const layoutType = watch('layoutType');
  const [videoCounts, setVideoCounts] = useState(0);

  useEffect(() => {
    setVideoCounts(layoutType.split('x').reduce((acc, item) => +acc * +item));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layoutType]);

  const selectInput = useMemo(() => {
    const arr = new Array(videoCounts).fill(0);
    return (
      <>
        {arr.map((i, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={index + i}>
            <Divider small />

            <div className={st.InputBlock} data-testid={`sourceInput-${index + 1}`}>
              <span>{`${index + 1}.`}</span>
              <Control.Select
                control={control}
                data-testid='SourceSelect'
                id={`${index + 1}Screen`}
                isClearable
                menuPlacement="top"
                name={`${index + 1}Screen`}
                options={sources}
                style={{ zIndex: 100 }}
              />
            </div>
          </React.Fragment>
        ))}
      </>
    );
  }, [videoCounts]);

  const onSelectLayoutType = (type) => setValue('layoutType', type);

  return (
    <form onSubmit={handleSubmit((values) => {
      const updatedValues = Object.keys(values).filter((k) => {
        if (k === 'layoutType') return true;
        if (parseInt(k, 10) <= videoCounts) return true;
        return false;
      }).reduce((obj, key) => {
        obj[key] = values[key];
        return obj;
      }, {});
      onSubmit(updatedValues);
    })}
    >
      <div className={st.LayoutsRoot}>
        <div>{t('lunapoint:choose_layout_type')}</div>
        <div className={st.Layouts}>
          <div className={st.LayoutCard} data-testid="vertical" onClick={() => onSelectLayoutType('1x2')}>
            <img alt="vertical" className={st.Assets} src={vertical} />
            <Control.Radio {...register('layoutType')} data-testid='layoutType' value="1x2" />
          </div>

          <div className={st.LayoutCard} data-testid="horizontal" onClick={() => onSelectLayoutType('2x1')}>
            <img alt="horizontal" className={st.Assets} src={horizontal} />
            <Control.Radio {...register('layoutType')} data-testid='layoutType' value="2x1" />
          </div>

          <div className={st.LayoutCard} onClick={() => onSelectLayoutType('2x2')}>
            <img alt="fourParts" className={st.Assets} src={fourParts} />
            <Control.Radio {...register('layoutType')} data-testid='layoutType' value="2x2" />
          </div>

          <div className={st.LayoutCard} onClick={() => onSelectLayoutType('3x2')}>
            <img alt="3x2" className={st.Assets} src={x32} />
            <Control.Radio {...register('layoutType')} data-testid='layoutType' value="3x2" />
          </div>

          <div className={st.LayoutCard} onClick={() => onSelectLayoutType('3x3')}>
            <img alt="3x3" className={st.Assets} src={x33} />
            <Control.Radio {...register('layoutType')} data-testid='layoutType' value="3x3" />
          </div>

          <div className={st.LayoutCard} onClick={() => onSelectLayoutType('4x3')}>
            <img alt="4x4" className={st.Assets} src={x43} />
            <Control.Radio {...register('layoutType')} data-testid='layoutType' value="4x3" />
          </div>

          <div className={st.LayoutCard} onClick={() => onSelectLayoutType('4x4')}>
            <img alt="4x4" className={st.Assets} src={x44} />
            <Control.Radio {...register('layoutType')} data-testid='layoutType' value="4x4" />
          </div>

          <div className={st.LayoutCard} onClick={() => onSelectLayoutType('5x4')}>
            <img alt="5x4" className={st.Assets} src={x54} />
            <Control.Radio {...register('layoutType')} data-testid='layoutType' value="5x4" />
          </div>

          <div className={st.LayoutCard} onClick={() => onSelectLayoutType('5x5')}>
            <img alt="5x5" className={st.Assets} src={x55} />
            <Control.Radio {...register('layoutType')} data-testid='layoutType' value="5x5" />
          </div>
        </div>
      </div>

      <div className={st.Inputs}>
        {selectInput}
      </div>

      <Divider small />
      <div className={st.Submit}>
        <Control.Button data-testid='SubmitButton' fullWidth type="submit">
          {t('form.submit')}
        </Control.Button>
      </div>
    </form>
  );
}

export const SettingsModal = connect((state) => ({
  sources: selectStreamOptions(state),
}))(SettingsModalComponent);
